module.exports = __webpack_public_path__ + "img/tab51000bonuscoins.0f8afccf.png";